import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  returnPassengerTypeCount,
  returnPassengerTypeCountByFlight,
} from '../../../../utils/utility/booking';
import FormatLastNumberColor from '../../../common/formatPriceLastDigits';
import { numberWithCommas } from '../../../../utils/consts/index';

const PriceDetails = ({ priceList, parsedQueryStr, item, intl, isAgency }) => {
  const hasPriceList = priceList.filter((item) => item.flightName).length > 0;
  return (
    <div className="col-12 p-0 m-0  font-smaller rounded mb-2 ">
      <div className="card shadow-lg ">
        <div className="card-header bg-primary text-white p-0 m-0 pt-2">
          <h5 className="text-center w-100 font-weight-bold text-uppercase  font-smaller ">
            <FormattedMessage id="booking.pricedetail" />
            &nbsp;
            {item?.Currency?.toLowerCase() === 'irr' ||
            item?.moneyUnit?.moneyUnit?.toLowerCase() === 'irr'
              ? intl.formatMessage({
                  id: 'booking.toman',
                  defaultMessage: 'booking.toman',
                })
              : item?.Currency || item?.moneyUnit?.moneyUnit}
          </h5>
        </div>
        <div className="card-body p-0">
          <div className="d-flex border-bottom col-12 p-0 flex-row text-third font-weight-bold pt-2">
            {hasPriceList && (
              <div className="col-3 p-0 d-flex justify-content-center font-smaller">
                <FormattedMessage
                  id="booking.flights"
                  defaultMessage="booking.flights"
                />
              </div>
            )}
            <div
              className={`${
                hasPriceList ? 'col-2' : 'col-3'
              } d-flex justify-content-center font-smaller`}
            >
              <FormattedMessage
                id="booking.passengertype"
                defaultMessage="booking.passengertype"
              />
            </div>
            <div
              className={`${
                hasPriceList ? 'col-2' : 'col-3'
              } justify-content-center  d-flex font-smaller`}
            >
              <FormattedMessage
                id="booking.fareprice"
                defaultMessage="booking.fareprice"
              />
            </div>

            <div
              className={`${
                hasPriceList ? 'col-2' : 'col-3'
              } justify-content-center  d-flex font-smaller `}
            >
              <FormattedMessage id="booking.tax" defaultMessage="booking.tax" />
            </div>

            <div
              className={`${
                hasPriceList ? 'col-3' : 'col-4'
              } justify-content-center d-flex font-smaller`}
            >
              <FormattedMessage
                id="booking.price"
                defaultMessage="booking.price"
              />
            </div>
          </div>
          {/* show all passenger price with tax */}
          {priceList.map((priceItem, index) => {
            if (priceItem.key !== 'Total') {
              let count = Object.entries(parsedQueryStr).length
                ? returnPassengerTypeCount(priceItem.key, parsedQueryStr)
                : returnPassengerTypeCountByFlight(priceItem.key, item.flights);
              if (count > 0) {
                return (
                  <div
                    key={`priceDetail-${index}`}
                    className="d-flex border-bottom col-12 p-0 flex-row text-third font-smaller py-1 font-weight-bold"
                  >
                    {hasPriceList && (
                      <div
                        className={`d-flex col-3 p-0 text-uppercase  justify-content-center text-secondary`}
                      >
                        {priceItem.flightName}
                      </div>
                    )}
                    <div
                      className={`d-flex ${
                        hasPriceList ? 'col-2' : 'col-3'
                      } text-uppercase  text-dark justify-content-center`}
                    >
                      <FormattedMessage
                        id={`booking.${priceItem.key.toLowerCase()}`}
                        defaultMessage={`booking.${priceItem.key.toLowerCase()}`}
                      />
                    </div>
                    <div
                      className={`d-flex   ${
                        hasPriceList ? 'col-2' : 'col-3'
                      }  justify-content-center`}
                    >
                      <FormatLastNumberColor
                        number={Math.round(
                          priceItem.BaseFare || priceItem.baseFare || 0,
                          0,
                        )}
                        mainColor={'dark'}
                        lastColor={'third'}
                      />
                    </div>
                    <div
                      className={`${
                        hasPriceList ? 'col-2' : 'col-3'
                      } d-flex col-2 justify-content-center`}
                    >
                      <FormatLastNumberColor
                        number={Math.round(
                          priceItem.Tax || priceItem.tax || 0,

                          0,
                        )}
                        mainColor={'dark'}
                        lastColor={'third'}
                      />
                    </div>
                    <div
                      className={`${
                        hasPriceList ? 'col-3' : 'col-4'
                      } d-flex  text  text-dark justify-content-center font-smaller`}
                    >
                      <span className="text-secondary text-nowrap font-smaller ">
                        {`${count} x `}
                      </span>
                      &nbsp;
                      <span>
                        {/* because all of all price is in irr convert it to toman */}
                        {/* {` ${numberWithCommas(
                          (item.TotalPrice / 260000).toFixed(2)
                        )}`} */}
                        {` ${numberWithCommas(
                          (
                            priceItem?.TotalPrice / 10 ||
                            priceItem?.totalPrice / 10 ||
                            0
                          ).toFixed(0),
                        )}`}
                      </span>
                    </div>
                  </div>
                );
              }
            }
          })}
          {/* show total price */}
          {priceList[priceList.length - 1].key === 'Total' && (
            <div className="d-flex flex-row  px-2 justify-content-center">
              <div className="d-flex font-smaller py-1 font-weight-bold text-dark justify-content-center align-items-center px-2 p-0 m-0 col-8">
                <div className="d-flex font-smaller text-nowrap  font-weight-bold text-dark justify-content-end align-items-center px-1 p-0 m-0 ">
                  <FormattedMessage
                    id="booking.allpassengerprice"
                    defaultMessage="booking.allpassengerprice"
                  />
                  {' : '}
                </div>
                <div
                  className="d-flex font-smaller font-weight-bold text-secondary px-1 py-0 justify-content-end align-items-center border-third"
                  style={{
                    borderLeft: name === 'en' ? '1px dotted' : '0',
                    borderRight: name === 'fa' ? '1px dotted' : '0',
                    // backgroundColor: "#f3eeee"
                  }}
                >
                  {/* show total price in two color but now comment it in FormatLastNumberColor */}
                  <FormatLastNumberColor
                    number={Math.round(
                      priceList[priceList.length - 1].TotalPrice,
                      0,
                    )}
                    mainColor={'secondary'}
                    lastColor={'third'}
                  />
                </div>
              </div>
            </div>
          )}{' '}
          {priceList[priceList.length - 1].key === 'Total' &&
            priceList[priceList.length - 1].Commission !== 0 && (
              <div className="d-flex flex-row justify-content-end px-2">
                <div className="d-flex font-smaller py-1 font-weight-bold text-dark align-items-center px-2 p-0 m-0 col-8">
                  <div className="d-flex font-smaller  font-weight-bold text-dark justify-content-end align-items-center px-2 p-0 m-0 col-8">
                    <FormattedMessage
                      id={`booking.${
                        isAgency ? 'agenycommission' : 'afterdiscount'
                      }`}
                    />
                    {' : '}
                  </div>
                  <div
                    className=" col-4 d-flex font-small font-weight-bold text-secondary py-0 px-1 justify-content-end align-items-center border-third"
                    style={{
                      borderLeft: name === 'en' ? '1px dotted' : '0',
                      borderRight: name === 'fa' ? '1px dotted' : '0',
                      // backgroundColor: "#f3eeee"
                    }}
                  >
                    {/* show total price in two color but now comment it in FormatLastNumberColor */}
                    <FormatLastNumberColor
                      number={
                        isAgency
                          ? Math.abs(
                              Math.round(
                                priceList[priceList.length - 1].Commission,
                                0,
                              ),
                            )
                          : Math.round(
                              priceList[priceList.length - 1].TotalPrice,
                            )
                      }
                      mainColor={'secondary'}
                      lastColor={'third'}
                    />
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
export default injectIntl(PriceDetails);
